export function errorHandler(error, key = 'message') {
  let message = 'Something went wrong'
  if (error instanceof Error) {
    message = error?.[key]
  }
  return message
}

export function customUAAErrorHandler(error) {
  let code
  let mfa_method = ''
  if (error instanceof Error) {
    code = error.code
    mfa_method = error.mfa_method
  }
  return { code, mfa_method }
}
